export default __webpack_public_path__ + "static/media/news80.214bee96.jpg";